module.exports = __webpack_public_path__ + "570d7ef52d723b4307e5fa94a044e457.mp3";